import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: 'multisite-verify-email-landing-page',
  templateUrl: './verify-email-landing-page.component.html',
  styleUrls: ['./verify-email-landing-page.component.scss'],
  imports: [
    TranslocoDirective,
  ],
})
export class VerifyEmailLandingPageComponent implements OnInit, OnDestroy {

  urlFragments = {
    'basePath': 'api/v1/email/verify/',
    'id': null,
    'hash': null,
    'expires': null,
    'signature': null,
  };
  fullUrl : string = null;
  verifySub;
  loginSub;
  loading = false;
  success = null;
  error = null;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router : Router
    ) { }
  
  verify (){
    this.loading = true;
    this.verifySub = this.authService.verify(this.fullUrl).subscribe(
      response => {
        this.loading = false;
        this.authService.setVerificationSuccess(true);
        if(this.authService.token){
          this.router.navigate(['/']);
          //TODO : this is not yet good user experience. We need to show a confirmation that the email verification (probably an email change) was successful. Add a toaster or other way of showing this.
        } else {
          this.router.navigate(['/login']); // User not logged in, so probably a new user verifying their email for the first time. The login page will show a Success message.
        }
      },
      errorMessage => {
        this.error = errorMessage;
        this.loading = false;
      }
    );

  }

  generateUrl (){
    this.urlFragments.id = this.route.snapshot.params['user_id'];
    this.urlFragments.hash = this.route.snapshot.params['hash'];

    const queryParams = { ...this.route.snapshot.queryParams };

    // Some verification links are malformed and contain '&amp;' in the query string,
    // which can produce an `amp;signature` key instead of `signature`.
    const normalisedSignature = queryParams['signature'] ?? queryParams['amp;signature'];
    const normalisedExpires = queryParams['expires'] ?? queryParams['amp;expires'];

    this.urlFragments.expires = normalisedExpires;
    this.urlFragments.signature = normalisedSignature;

    if (!this.urlFragments.expires || !this.urlFragments.signature) {
      const rawQuery = this.router.url.includes('?') ? this.router.url.split('?')[1] : '';
      const normalisedQuery = rawQuery.replace(/&amp;/g, '&');
      const parsedParams = new URLSearchParams(normalisedQuery);

      this.urlFragments.expires = this.urlFragments.expires ?? parsedParams.get('expires');
      this.urlFragments.signature = this.urlFragments.signature ?? parsedParams.get('signature');
    }

    this.fullUrl =
      this.urlFragments.basePath +
      this.urlFragments.id +
      '/' +
      this.urlFragments.hash +
      '?expires=' +
      this.urlFragments.expires +
      '&signature=' +
      this.urlFragments.signature;
  }

  ngOnInit(): void {
   this.generateUrl();
   this.verify();
  }
  ngOnDestroy () : void {

  }
}
